import React, { useEffect, useState } from 'react';
import BookImg from '../../Images/img.png'
import '../../Styles/ConfirmLesson.css'
import { MAIN_URL } from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';

const ConfirmLesson = () => {

    const [courses, setCourses] = useState([]);
    useEffect(() => {
        axios.get(`${MAIN_URL}/courses/`).then((response) => {
            setCourses(response.data);
        }).catch((error) => {
            toast.error(`Error fetching courses: ${error.message || error}`);
        });
    }, []);

    return (
        <div className='confirm-lesson'>
            <h4 className="confirm-lesson-title">Confirmation of lessons</h4>
            {courses?.map((course, index) => (
                <div key={index} className='confirmation-container'>
                    <span>{index + 1}</span>
                    <div className="confirm-lesson-card1">
                        <img src={course?.photo} alt="" className="book-img" />
                        <div className="con-lesson-right">
                            <div className="con-lesson-block">
                                <h3 className="con-block-title">{course?.title}</h3>
                                <p className="con-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non. consectetur adipiscing elit. Ac a, porttitor ac arcu morbi bibendum interdum non</p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <div className="btns-wrapper">
                <button className="confirmation-cancel-btn"  >
                    Cancel
                </button>
                <button className="confirmation-btn"  >
                    Confirm all
                </button>
            </div>
        </div>
    );
}

export default ConfirmLesson;
